import { PiHouseLineBold, MdEditNote, GrAnalytics, TbDatabaseImport, MdDisplaySettings } from '@src/lib/react-icons'
import { IconType } from 'react-icons'

type subRoute = {
  /** url路徑 */
  path: string;
  /** 功能名稱 */
  name: string;
  /** 描述 */
  description: string;
}

interface RouteDefine {
  /** 模組名稱 */
  module: string;
  /** url路徑 */
  path: string;
  /** 描述 */
  description: string;
  /** 模組icon */
  Icon: IconType;
  /** 子目錄 */
  subMenu: subRoute[] | null;
}

export const routeMap: RouteDefine[] = [
  {
    module: 'dashboard',
    path: 'dashboard',
    description: '儀錶板',
    Icon: PiHouseLineBold,
    subMenu: null
  },
  {
    module: 'setting',
    path: 'setting',
    description: '作業參數設定',
    Icon: MdEditNote,
    subMenu: [
      { path: 'car-brand', name: 'carBrand', description: '品牌' },
      { path: 'car-model',  name: 'carModel', description: '車種' },
      { path: 'sfx', name: 'sfx', description: '規格(SFX)' },
      { path: 'pio', name: 'pio', description: '項目(PIO)' },
      // { path: 'car-part', name: 'carPart', description: '組裝區域' },
      { path: 'factory', name: 'factory', description: '廠區' },
      { path: 'station', name: 'station', description: '工位' },
      { path: 'shift', name: 'shift', description: '班別' }
    ] 
  },
  {
    module: 'report',
    path: 'report',
    description: '作業報表',
    Icon: GrAnalytics,
    subMenu: [
      { path: 'car-records', name: 'carRecords', description: '車輛紀錄' },
      { path: 'car-infos', name: 'carInfos', description: '車籍資料' },
      { path: 'pio-records', name: 'pioRecords', description: '項目(PIO)紀錄' },
      { path: 'employee-records', name: 'employeeRecords', description: '員工紀錄' },
      { path: 'car-statistics', name: 'carStatistics', description: '車輛整體統計' },
      { path: 'total-output', name: 'totalOutput', description: '總產量' }
    ]
  },
  {
    module: 'import',
    path: 'data-import',
    description: '外部資料匯入',
    Icon: TbDatabaseImport,
    subMenu: [
      { path: 'pio', name: 'pioItem', description: '項目(PIO)' },
      { path: 'sfx', name: 'sfx', description: '規格(SFX)' },
      { path: 'station', name: 'station', description: '工位參數' },
      { path: 'shift', name: 'shift', description: '班別參數' },
      // { path: 'car-part', name: 'carPart', description: '組裝區域參數' },
      { path: 'employee', name: 'employee', description: '員工資料' },
      { path: 'car-info', name: 'carInfo', description: '車輛資料' },
      { path: 'qa', name: 'qa', description: 'QA已完成資料' },
      { path: 'pio-arg', name: 'pioArg', description: '項目(PIO)參數資料' }
    ]
  },
  {
    module: 'system',
    path: 'system-management',
    description: '系統管理',
    Icon: MdDisplaySettings,
    subMenu: [
      { path: 'users', name: 'user', description: '使用者管理' },
      { path: 'roles', name: 'role', description: '角色管理' },
      { path: 'employees', name: 'employee', description: '員工資料管理' },
      { path: 'api-logs', name: 'apiLog', description: '系統Log' }
    ]
  }
]
